var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { ClientLotteryClientService } from "../../../../../services/modules/client/client-lottery-client-service";
var FaqDialog = /** @class */ (function () {
    function FaqDialog(lotteryClientService) {
        this.lotteryClientService = lotteryClientService;
    }
    FaqDialog.prototype.activate = function (lotteryId) {
        this.lotteryId = lotteryId;
    };
    FaqDialog.prototype.getAdditionalInfo = function () {
        return this.lotteryClientService.getLotteryAdditionalInfo(this.lotteryId);
    };
    FaqDialog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService])
    ], FaqDialog);
    return FaqDialog;
}());
export { FaqDialog };
